"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstRolloutOnboardingConfig = void 0;
exports.firstRolloutOnboardingConfig = {
    hasFirstRolloutOnboardingWhitelist: true,
};
